export const DEFAULT_MAX_DISTANCE_ALLOWED_FOR_LOCATION_VERIFICATION_IN_MILES = 130;

export const GET_GEOLOCATION_TIMEOUT_IN_MILLISECONDS = 6000;

export const MIN_ANDROID_OS_WITH_ALWAYS_ALLOW_OPTION = "10.0.0";

export const MILES_TO_METERS_MULTIPLIER = 0.000_621_371_2;

export enum UrgentShiftLocalStorage {
  GENERAL_PRIMER_PAGE_VIEWED = "generalPrimerPageViewed",
  LAST_LOCATION_PERMISSION_STATUS = "lastLocationPermissionStatus",
  USER_DISABLED_FULL_LOCATION_PERMISSION = "userDisabledFullLocationPermission",
}

export enum LocationAccuracyStatus {
  FULL = "full",
  REDUCED = "reduced",
}

export enum TripTrackingTrigger {
  APP_OPEN = "appOpen",
  LOCATION_UPDATE = "locationUpdate",
  SILENT_PUSH_NOTIFICATION = "silentPushNotification",
  URGENT_SHIFT_BOOKING = "urgentShiftBooking",
}

export enum LocationTrackingMode {
  STOP = "stop",
  PASSIVE = "passive",
  AGGRESSIVE = "aggressive",
  ONSITE = "onsite",
}
